import { EmailIcon, Link, Spacer } from 'internalLibrary';
import styles from './Contact.module.scss';

export interface ContactMailProps {
  email: string;
}

export const ContactMail = ({ email }: ContactMailProps) => {
  return (
    <Link
      className={styles.link}
      href={`mailto:${email}`}
      leftIcon={<EmailIcon />}
    >
      <Spacer marginLeft="7px">{email}</Spacer>
    </Link>
  );
};
